import { ResearchCommunicationFromList } from 'civil-status/view-models/communication-from-list';
import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';

export const transformResearchCommunicationFromList = (
  values: ResearchCommunicationFromList,
  page?: number,
  rowsPerPage?: number
): string => {
  const transformedFilters: OperationObject = {
    codComunicazione: {
      value: values.code || '',
      operation: Operation.EQUALS,
    },
    codStatoComunicazione: {
      value: values.state || '',
      operation: Operation.EQUALS,
    },
    codiceAmbito: {
      value: values.scope || '',
      operation: Operation.EQUALS,
    },
    tipoAttoSecondario: {
      value: values.typeEvent || '',
      operation: Operation.EQUALS,
    },
    formazioneDa: {
      value: values.dateStart ? values.dateStart.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
    formazioneA: {
      value: values.dateEnd ? values.dateEnd.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
    codiceOperatoreInserimento: {
      value: values?.codOperator || '',
      operation: Operation.EQUALS,
    },
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: {},
    page: page || 0,
    rowsPerPage: rowsPerPage || 10,
  })}`;
};
